export const environment = {
  firebase: {
    projectId: 'contler-dev',
    appId: '1:424830318314:web:07bf71086a5b858347c993',
    databaseURL: 'https://contler-dev.firebaseio.com',
    storageBucket: 'contler-dev.appspot.com',
    apiKey: 'AIzaSyC7-kFPHWTHaKaP2WFjIXWoAaf9QfSyr8Q',
    authDomain: 'contler-dev.firebaseapp.com',
    messagingSenderId: '424830318314',
    measurementId: 'G-YLK13DG5VC',
  },
  apiUrl: 'https://api-gateway-5f5x03je.uc.gateway.dev/',
  apiReservation: 'https://reservation-gmpfywsldq-uc.a.run.app/',
  assistantUrl: 'https://assistants-424830318314.us-central1.run.app/',
  continueSignInUrl: 'https://onbording-dev-cff9a.web.app/continue-signin',
  guestUrl: 'https://contler-dev.web.app',
  contlerApp: 'https://hotel-proxy-dev.web.app/',
  vapiPublicKey: '1a6911fb-647e-45e3-b652-90e7feb68fda',
};
